<template>
  <i
    v-if="visibilityKey"
    v-tooltip="visibilityIconData.tooltip"
    :class="visibilityIconData.icon"
    :data-testid="visibilityKey"
    class="fa fa-solid tw-text-sm tw-text-sf-slate hover:tw-opacity-70"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Segment } from '../../types/index'
import useSegmentVisibilities from '../../composables/use-segment-visibilities'

const visibilityData = useSegmentVisibilities()

interface Props {
  segment: Segment
}

const props = defineProps<Props>()
const visibilityKey = computed(() => props.segment.visibility)
const visibilityIconData = computed(() => {
  const key = visibilityKey.value
  return key && visibilityData[key]
    ? visibilityData[key]
    : { icon: '', tooltip: '' }
})
</script>
